import store from 'store';
import { api } from './wemble-api';
import { getStatusSource } from './getStatusSource';
import { HeartbeatAction } from './wemble-api.generated';

/** Fire-and-forget telemetry. Backend dedupes same action+details within 10 min. */
export const trackAction = (action: HeartbeatAction, details?: any) => {
  const thunk = api.endpoints.trackAction.initiate({
    trackActionBody: {
      action,
      details,
      source: getStatusSource(),
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
    },
  });
  // Cast: store.dispatch type inference strips thunk middleware in production builds.
  const result = (store.dispatch as any)(thunk);
  if (result && typeof result.catch === 'function') result.catch(() => {});
};
